export const VideoType = {
    m3u8: 'application/x-mpegURL',
    hls: 'application/x-mpegURL',
    youtube: 'youtube',
    twitch: 'twitch',
    perform: 'perform',
    betGenius: 'betGenius',
    beter: 'beter',
};

export type VideoType = typeof VideoType[keyof typeof VideoType];
